import { Vector } from '../vector';
/**
 * **Deprecation Notice:** `Dom.isVector` is deprecated and will be moved in next
 * major release. Use `Vector.isVector()` instead.
 *
 * @deprecated
 */
export const isVector = Vector.isVector;
/**
 * **Deprecation Notice:** `Dom.createVector` is deprecated and will be moved
 * in next major release. Use `Vector.create()` instead.
 *
 * @deprecated
 */
export const createVector = Vector.create;
/**
 * **Deprecation Notice:** `Dom.createVectors` is deprecated and will be moved
 * in next major release. Use `Vector.createVectors()` instead.
 *
 * @deprecated
 */
export const createVectors = Vector.createVectors;
//# sourceMappingURL=vector.js.map